const MOUNT_ID = 'modals';

export function modalContainer() {
  const existing = document.getElementById(MOUNT_ID);
  if (existing) {
    return existing;
  }

  const container = document.createElement('div');
  container.id = MOUNT_ID;
  document.body.appendChild(container);

  return container;
}
